/**
 * マニフェスト管理 運搬終了報告切り替え
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/managements`

const manifest_management_manifest_transport = {
  namespaced: true,
  actions: {
    show ({ commit }, { manifest_id, id }) {
      const api_path = `${API_PATH}/${manifest_id}/manifest_transports/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * マニフェストの更新
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { manifest_id, id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${manifest_id}/manifest_transports/${id}`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { manifest_id, id }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${manifest_id}/manifest_transports/${id}`
        Vue.$http.delete(api_path).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '取消しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default manifest_management_manifest_transport
